export const PHONE_OTP_SESSION_SECONDS = 5 * 60;

const PHONE_OTP_SESSION_ERROR_CODES = new Set([
  "auth/code-expired",
  "auth/invalid-verification-id",
  "auth/missing-verification-id",
  "auth/session-expired",
]);

export const createPhoneOtpDeadline = (now = Date.now()) =>
  now + PHONE_OTP_SESSION_SECONDS * 1000;

export const getPhoneOtpSecondsRemaining = (
  expiresAt,
  now = Date.now(),
) => {
  const deadline = Number(expiresAt);
  if (!Number.isFinite(deadline) || deadline <= 0) return 0;

  return Math.max(0, Math.ceil((deadline - now) / 1000));
};

export const formatPhoneOtpTime = (seconds) => {
  const safeSeconds = Math.max(0, Math.ceil(Number(seconds) || 0));
  const minutes = Math.floor(safeSeconds / 60);
  const remainder = safeSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(remainder).padStart(2, "0")}`;
};

export const isFirebasePhoneOtpSessionError = (error) =>
  PHONE_OTP_SESSION_ERROR_CODES.has(error?.code);
